import type { DOMOutputSpec, MarkSpec } from 'prosemirror-model';

import type { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class StrikethroughMark implements MarkSpec {
  public static readonly markName = MarkName.Strikethrough;
  public parseDOM = [
    { tag: 's' },
    { tag: 'strikethrough' },
    {
      tag: '*',
      style: 'text-decoration=line-through',
      consuming: false,
      getAttrs: (node: HTMLElement) => {
        const isChecklistItem = node.dataset.componentType === 'checklist-item';
        if (isChecklistItem) return false;

        return node.style.textDecoration === 'line-through' ? null : false;
      },
    },
  ];
  public toDOM(): DOMOutputSpec {
    return ['s', 0];
  }
}

export type StrikethroughSchema = RtSchemaType<any, typeof StrikethroughMark>;
